import { render, staticRenderFns } from "./Mail.vue?vue&type=template&id=4e726dda&scoped=true"
import script from "./Mail.vue?vue&type=script&lang=js"
export * from "./Mail.vue?vue&type=script&lang=js"
import style0 from "./Mail.vue?vue&type=style&index=0&id=4e726dda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e726dda",
  null
  
)

export default component.exports